import useSandbox from "./composables/useSandbox.js";
import { defineNuxtPlugin } from "#imports";
export default defineNuxtPlugin(() => {
  useSandbox();
});
